import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
import Gallery757 from './projects/757gallery.png';
import StudMobile757 from './projects/757studMobile.png';
import GLcover from './projects/GLcover.png';
import HHRcover from './projects/HHRcover.png';
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    DETAILED: "Personal Projects",
    MOCKUPS: "Commisioned",
    YOUTUBE: "Code Samples",
  };

  const types = {
    DOCUMENT: "document",
    IMAGE: "code"
  };

  const projectsData = [
    {
      title: "757 Exotics Website",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Created a barebones ReactJS site for the customer to host info about their dog breeding business. Created a backend that allows the customer to update all the info themselves and only needs minor updates from me if they want a layout change.",
        client: "757 Exotics",
        technologies: "ReactJS, HTML5, CSS3, NodeJS, MongoDB",
        industry: "Animal Husbandry",
        date: "July 16, 2019",
        url: {
          name: "http://757exotics.com/",
          link: "http://757exotics.com/",
        },

        sliderImages: [
          StudMobile757
        ],
      },

      thumbImage: Gallery757,

      categories: [filters.MOCKUPS, filters.DETAILED],
    },
    {
      title: "My Grocery List",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "A grocery list of the items I use in my household that keeps track of what I need. Uses localstorage to store list and checkbox state so it keeps your progress. Future updates to add items on the fly and to export the list are planned.",
        client: "MySelf",
        technologies: "ReactJS, HTML5, CSS3, NodeJS",
        industry: "Personal Project",
        date: "Feb 10, 2019",
        url: {
          name: "My Grocery List",
          link: "https://codepipeline-grocerylist.s3.amazonaws.com/index.html",
        },
        sliderImages: [],
      },
      thumbImage: GLcover,
      categories: [filters.DETAILED],
    },
    {
      title: "Happy Hour Roulette",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Roulette Wheel made with D3 to take in locations given by the Google Places API to randomly choose where you should spend happy hour.",
        client: "MySelf",
        technologies: "ReactJS, HTML5, CSS3, NodeJS, D3, Google Places",
        industry: "Personal Project",
        date: "Aug 5, 2020",
        url: {
          name: "Happy Hour Roulette",
          link: "https://happyhourroulette.s3.amazonaws.com/index.html",
        },
        sliderImages: [],
      },
      thumbImage: HHRcover,
      categories: [filters.DETAILED],
    }
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">Portfolio</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            Some of my most recent projects
          </h2>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " + (filterKey === oneKey ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && (
                                <i className="fa fa-desktop"></i>
                              )}
                              {project.type === types.IMAGE && (
                                <i className="fa fa-code"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
